import pages from './pages.json';

// pages.json lists every page that has (or will have) translated routes.
// A page that is not listed — or is listed with `live: false` — has no
// switcher and no suggestion. Flip `live` to true once its routes ship.
export const PAGES = pages;

const normalize = (path = '') => {
  const clean = path.split('?')[0].split('#')[0];
  return clean.endsWith('/') ? clean : `${clean}/`;
};

export function getPageByPath(path) {
  const clean = normalize(path);

  for (const page of PAGES) {
    const locale = Object.keys(page.paths).find((l) => page.paths[l] === clean);
    if (locale) return { page, locale };
  }

  return null;
}

// Locales offered for a page. The US version (`usPath`, a root page) is listed
// first as a link-only option; it is not in `paths`, so US pages themselves
// are never treated as translated pages (getTranslationsForPath still gives
// them the switcher).
const localesFor = (page) =>
  page.usPath ? { 'en-US': page.usPath, ...page.paths } : page.paths;

// Shape consumed by the language switcher and suggestion:
// { id, entry: { [locale]: path }, currentLocale } or null.
export function getTranslationsForPath(path) {
  const found = getPageByPath(path);

  // A root (US) page that has LATAM versions gets the same switcher, with
  // en-US as the current locale. Pages without a LATAM equivalent get none.
  if (!found) {
    const usPage = PAGES.find(
      (page) => page.live && page.usPath && page.usPath === normalize(path)
    );
    return usPage
      ? {
          id: usPage.id,
          entry: localesFor(usPage),
          currentLocale: 'en-US',
        }
      : null;
  }

  if (!found.page.live) return null;

  return {
    id: found.page.id,
    entry: localesFor(found.page),
    currentLocale: found.locale,
  };
}

export function getPathFor(id, locale, { includePlanned = false } = {}) {
  const page = PAGES.find((p) => p.id === id);
  const path = page && localesFor(page)[locale];
  if (!path) return null;
  if (!page.live && !includePlanned) return null;
  return path;
}
